var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "540px",
      "overflow-y": "scroll",
      "overflow-x": "hidden"
    }
  }, [_c('el-form', {
    ref: "from",
    staticStyle: {
      "padding-left": "3%",
      "padding-right": "8%"
    },
    attrs: {
      "model": _vm.from,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "城市",
      "prop": "city_id"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "small",
      "placeholder": _vm.postPlaceholder,
      "clearable": ""
    },
    model: {
      value: (_vm.form.city_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "city_id", $$v)
      },
      expression: "form.city_id"
    }
  }, _vm._l((_vm.$globals.cityList), function(item) {
    return _c('el-option', {
      key: item.city,
      attrs: {
        "label": item.city,
        "value": item.city
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "最低工资",
      "prop": "minimum_wage"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入最低工资",
      "size": "small"
    },
    model: {
      value: (_vm.form.minimum_wage),
      callback: function($$v) {
        _vm.$set(_vm.form, "minimum_wage", $$v)
      },
      expression: "form.minimum_wage"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-left": "7%"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v("五险")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v("缴费基数")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v("缴费方式")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v("个人比例")])])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin": "3% 0 0 7%"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('div', {}, [_vm._v("养老")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "type": "number",
      "size": "mini",
      "placeholder": ""
    },
    model: {
      value: (_vm.form.provideAged_base),
      callback: function($$v) {
        _vm.$set(_vm.form, "provideAged_base", $$v)
      },
      expression: "form.provideAged_base"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.form.provideAged_pay_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "provideAged_pay_type", $$v)
      },
      expression: "form.provideAged_pay_type"
    }
  }, [_vm._v("比例缴费")]), _vm._v(" "), _c('el-radio', {
    staticStyle: {
      "margin-left": "-20px"
    },
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.form.provideAged_pay_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "provideAged_pay_type", $$v)
      },
      expression: "form.provideAged_pay_type"
    }
  }, [_vm._v("固定缴费")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "size": "mini",
      "placeholder": ""
    },
    model: {
      value: (_vm.form.provideAged_proportion),
      callback: function($$v) {
        _vm.$set(_vm.form, "provideAged_proportion", $$v)
      },
      expression: "form.provideAged_proportion"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin": "3% 0 0 7%"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('div', {}, [_vm._v("失业")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "type": "number",
      "size": "mini",
      "placeholder": ""
    },
    model: {
      value: (_vm.form.unemployment_base),
      callback: function($$v) {
        _vm.$set(_vm.form, "unemployment_base", $$v)
      },
      expression: "form.unemployment_base"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.form.unemployment_pay_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "unemployment_pay_type", $$v)
      },
      expression: "form.unemployment_pay_type"
    }
  }, [_vm._v("比例缴费")]), _vm._v(" "), _c('el-radio', {
    staticStyle: {
      "margin-left": "-20px"
    },
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.form.unemployment_pay_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "unemployment_pay_type", $$v)
      },
      expression: "form.unemployment_pay_type"
    }
  }, [_vm._v("固定缴费")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "size": "mini",
      "placeholder": ""
    },
    model: {
      value: (_vm.form.unemployment_proportion),
      callback: function($$v) {
        _vm.$set(_vm.form, "unemployment_proportion", $$v)
      },
      expression: "form.unemployment_proportion"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin": "3% 0 0 7%"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('div', {}, [_vm._v("工伤")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "type": "number",
      "size": "mini",
      "placeholder": ""
    },
    model: {
      value: (_vm.form.industrial_injury_base),
      callback: function($$v) {
        _vm.$set(_vm.form, "industrial_injury_base", $$v)
      },
      expression: "form.industrial_injury_base"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.form.industrial_injury_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "industrial_injury_type", $$v)
      },
      expression: "form.industrial_injury_type"
    }
  }, [_vm._v("比例缴费")]), _vm._v(" "), _c('el-radio', {
    staticStyle: {
      "margin-left": "-20px"
    },
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.form.industrial_injury_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "industrial_injury_type", $$v)
      },
      expression: "form.industrial_injury_type"
    }
  }, [_vm._v("固定缴费")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "size": "mini",
      "placeholder": ""
    },
    model: {
      value: (_vm.form.industrial_injury_proportion),
      callback: function($$v) {
        _vm.$set(_vm.form, "industrial_injury_proportion", $$v)
      },
      expression: "form.industrial_injury_proportion"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin": "3% 0 0 7%"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('div', {}, [_vm._v("医疗")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "type": "number",
      "size": "mini",
      "placeholder": ""
    },
    model: {
      value: (_vm.form.medical_care_base),
      callback: function($$v) {
        _vm.$set(_vm.form, "medical_care_base", $$v)
      },
      expression: "form.medical_care_base"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.form.medical_care_pay_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "medical_care_pay_type", $$v)
      },
      expression: "form.medical_care_pay_type"
    }
  }, [_vm._v("比例缴费")]), _vm._v(" "), _c('el-radio', {
    staticStyle: {
      "margin-left": "-20px"
    },
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.form.medical_care_pay_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "medical_care_pay_type", $$v)
      },
      expression: "form.medical_care_pay_type"
    }
  }, [_vm._v("固定缴费")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "size": "mini",
      "placeholder": ""
    },
    model: {
      value: (_vm.form.medical_care_proportion),
      callback: function($$v) {
        _vm.$set(_vm.form, "medical_care_proportion", $$v)
      },
      expression: "form.medical_care_proportion"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin": "3% 0 0 7%"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('div', {}, [_vm._v("生育")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "type": "number",
      "size": "mini",
      "placeholder": ""
    },
    model: {
      value: (_vm.form.birth_base),
      callback: function($$v) {
        _vm.$set(_vm.form, "birth_base", $$v)
      },
      expression: "form.birth_base"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.form.birth_pay_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "birth_pay_type", $$v)
      },
      expression: "form.birth_pay_type"
    }
  }, [_vm._v("比例缴费")]), _vm._v(" "), _c('el-radio', {
    staticStyle: {
      "margin-left": "-20px"
    },
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.form.birth_pay_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "birth_pay_type", $$v)
      },
      expression: "form.birth_pay_type"
    }
  }, [_vm._v("固定缴费")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "size": "mini",
      "placeholder": ""
    },
    model: {
      value: (_vm.form.birth_proportion),
      callback: function($$v) {
        _vm.$set(_vm.form, "birth_proportion", $$v)
      },
      expression: "form.birth_proportion"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin": "3% 0 0 7%"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('div', {}, [_vm._v("大额医疗")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "type": "number",
      "size": "mini",
      "placeholder": ""
    },
    model: {
      value: (_vm.form.large_treatment_base),
      callback: function($$v) {
        _vm.$set(_vm.form, "large_treatment_base", $$v)
      },
      expression: "form.large_treatment_base"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.form.large_treatment_pay_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "large_treatment_pay_type", $$v)
      },
      expression: "form.large_treatment_pay_type"
    }
  }, [_vm._v("比例缴费")]), _vm._v(" "), _c('el-radio', {
    staticStyle: {
      "margin-left": "-20px"
    },
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.form.large_treatment_pay_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "large_treatment_pay_type", $$v)
      },
      expression: "form.large_treatment_pay_type"
    }
  }, [_vm._v("固定缴费\n                ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "size": "mini",
      "placeholder": ""
    },
    model: {
      value: (_vm.form.large_treatment_proportion),
      callback: function($$v) {
        _vm.$set(_vm.form, "large_treatment_proportion", $$v)
      },
      expression: "form.large_treatment_proportion"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {}, [_vm._v("\n                    医保大额扣费月份\n                    "), _c('el-select', {
    staticStyle: {
      "width": "42%",
      "margin-left": "5px"
    },
    attrs: {
      "size": "small",
      "placeholder": _vm.postPlaceholder,
      "clearable": ""
    },
    model: {
      value: (_vm.form.large_treatment_month),
      callback: function($$v) {
        _vm.$set(_vm.form, "large_treatment_month", $$v)
      },
      expression: "form.large_treatment_month"
    }
  }, _vm._l((_vm.monthList), function(item) {
    return _c('el-option', {
      key: item.label,
      attrs: {
        "label": item.label,
        "value": item.label
      }
    })
  }), 1)], 1)])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin": "3% 0 0 7%"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('div', {}, [_vm._v("公积金")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "type": "number",
      "size": "mini",
      "placeholder": ""
    },
    model: {
      value: (_vm.form.commonMpe_base),
      callback: function($$v) {
        _vm.$set(_vm.form, "commonMpe_base", $$v)
      },
      expression: "form.commonMpe_base"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.form.commonMpe_pay_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "commonMpe_pay_type", $$v)
      },
      expression: "form.commonMpe_pay_type"
    }
  }, [_vm._v("比例缴费")]), _vm._v(" "), _c('el-radio', {
    staticStyle: {
      "margin-left": "-20px"
    },
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.form.commonMpe_pay_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "commonMpe_pay_type", $$v)
      },
      expression: "form.commonMpe_pay_type"
    }
  }, [_vm._v("固定缴费")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "size": "mini",
      "placeholder": ""
    },
    model: {
      value: (_vm.form.commonMpe_proportion),
      callback: function($$v) {
        _vm.$set(_vm.form, "commonMpe_proportion", $$v)
      },
      expression: "form.commonMpe_proportion"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin": "5% 0 0 10%"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v("公司缴费比例")])])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-left": "10%",
      "margin-top": "2%"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v("公司")])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-left": "3%"
    },
    attrs: {
      "span": 2
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v("养老")])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-left": "1%"
    },
    attrs: {
      "span": 2
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v("失业")])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-left": "1%"
    },
    attrs: {
      "span": 2
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v("工伤")])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-left": "1%"
    },
    attrs: {
      "span": 2
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v("医疗")])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-left": "1%"
    },
    attrs: {
      "span": 2
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v("生育")])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-left": "1%"
    },
    attrs: {
      "span": 2
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v("大额医疗")])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-left": "1%"
    },
    attrs: {
      "span": 2
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v("公积金")])])], 1), _vm._v(" "), _vm._l((_vm.form.companyCount), function(item, index) {
    return _c('el-row', {
      key: index,
      staticStyle: {
        "margin": "1% 0 0 10%"
      }
    }, [_c('el-from', {
      ref: "rangeRuleForm",
      refInFor: true,
      attrs: {
        "model": _vm.form.companyList[index]
      }
    }, [_c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('el-select', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "placeholder": "请选择",
        "size": "small",
        "clearable": ""
      },
      model: {
        value: (_vm.form.companyList[index].pay_company),
        callback: function($$v) {
          _vm.$set(_vm.form.companyList[index], "pay_company", $$v)
        },
        expression: "form.companyList[index].pay_company"
      }
    }, _vm._l((_vm.partnerList), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "label": item.partner_abbreviation,
          "value": item.id
        }
      })
    }), 1)], 1), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "margin-left": "3%"
      },
      attrs: {
        "span": 2
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "90%"
      },
      attrs: {
        "size": "small",
        "placeholder": ""
      },
      model: {
        value: (_vm.form.companyList[index].pay_provideAged),
        callback: function($$v) {
          _vm.$set(_vm.form.companyList[index], "pay_provideAged", $$v)
        },
        expression: "form.companyList[index].pay_provideAged"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "margin-left": "1%"
      },
      attrs: {
        "span": 2
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "90%"
      },
      attrs: {
        "size": "small",
        "placeholder": ""
      },
      model: {
        value: (_vm.form.companyList[index].pay_unemployment),
        callback: function($$v) {
          _vm.$set(_vm.form.companyList[index], "pay_unemployment", $$v)
        },
        expression: "form.companyList[index].pay_unemployment"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "margin-left": "1%"
      },
      attrs: {
        "span": 2
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "90%"
      },
      attrs: {
        "size": "small",
        "placeholder": ""
      },
      model: {
        value: (_vm.form.companyList[index].pay_industrial_injury),
        callback: function($$v) {
          _vm.$set(_vm.form.companyList[index], "pay_industrial_injury", $$v)
        },
        expression: "form.companyList[index].pay_industrial_injury"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "margin-left": "1%"
      },
      attrs: {
        "span": 2
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "90%"
      },
      attrs: {
        "size": "small",
        "placeholder": ""
      },
      model: {
        value: (_vm.form.companyList[index].pay_medical_care),
        callback: function($$v) {
          _vm.$set(_vm.form.companyList[index], "pay_medical_care", $$v)
        },
        expression: "form.companyList[index].pay_medical_care"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "margin-left": "1%"
      },
      attrs: {
        "span": 2
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "90%"
      },
      attrs: {
        "size": "small",
        "placeholder": ""
      },
      model: {
        value: (_vm.form.companyList[index].pay_birth),
        callback: function($$v) {
          _vm.$set(_vm.form.companyList[index], "pay_birth", $$v)
        },
        expression: "form.companyList[index].pay_birth"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "margin-left": "1%"
      },
      attrs: {
        "span": 2
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "90%"
      },
      attrs: {
        "size": "small",
        "placeholder": ""
      },
      model: {
        value: (_vm.form.companyList[index].pay_large_treatment),
        callback: function($$v) {
          _vm.$set(_vm.form.companyList[index], "pay_large_treatment", $$v)
        },
        expression: "form.companyList[index].pay_large_treatment"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "margin-left": "1%"
      },
      attrs: {
        "span": 2
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "90%"
      },
      attrs: {
        "size": "small",
        "placeholder": ""
      },
      model: {
        value: (_vm.form.companyList[index].pay_commonMpe),
        callback: function($$v) {
          _vm.$set(_vm.form.companyList[index], "pay_commonMpe", $$v)
        },
        expression: "form.companyList[index].pay_commonMpe"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "margin-left": "2%"
      },
      attrs: {
        "span": 2
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: ((index + 1) == _vm.form.companyCount.length),
        expression: "(index + 1) == form.companyCount.length"
      }],
      staticStyle: {
        "height": "25px",
        "margin-left": "3%",
        "margin-top": "5px"
      },
      attrs: {
        "src": require("../../../assets/icon/添加.png")
      },
      on: {
        "click": _vm.AddRecord
      }
    }), _vm._v(" "), _c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index != 0),
        expression: "index != 0"
      }],
      staticStyle: {
        "height": "25px",
        "margin-left": "10px",
        "margin-top": "5px"
      },
      attrs: {
        "src": require("../../../assets/icon/减少.png")
      },
      on: {
        "click": function($event) {
          return _vm.RemoveRecord(index)
        }
      }
    })])], 1)], 1)
  })], 2), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin": "3% 0 0 45%"
    },
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.add()
      }
    }
  }, [_vm._v("确 定")])], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4757aea4","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jcrsgl/Bxjsgl/Bxjsgl_add.vue
// module id = null
// module chunks = 